export const userHasAudiencesAccess = (user) => user.shouldShowAudiences();

export const userHasCompaniesAccess = (user) => user.shouldShowCompanies();

export const userHasDataEnrichmentAccess = (user) =>
  user.shouldShowDataEnrichment();

export const userHasDataEnrichmentLogsAccess = (user) =>
  user.shouldShowDataEnrichmentLogs();

export const userHasDashboardAccess = (user) => user.shouldShowDashboard();

export const userHasPeopleAccess = (user) => user.shouldShowPeople();

export const userHasICP = (user) => user.shouldShowICP();

export const userHasSettingsAccess = (user) => user.shouldShowSettings();

export const userHasSetupAccess = (user) => user.shouldShowSetup();

export const userHasInternalAccess = (user) => user.hasInternalAccess();

export const userHasFormsAccess = (user) => user.shouldShowForms();
